module.exports = __webpack_public_path__ + "assets/572757052b6bea654f2988e90096643a.jpg";